import { Component, OnInit } from '@angular/core';
import { CalendarService } from 'src/app/services/calendar.service';
import { PortalEvent } from 'src/app/classes/calendar';


@Component({
	selector: 'app-subscribed-event-list',
	templateUrl: './subscribed-event-list.component.html',
	styleUrls: [ './subscribed-event-list.component.css' ],
})
export class SubscribedEventListComponent implements OnInit {


	bLoading = true;
	subscribedEvents: PortalEvent[] = [];


	constructor(
		private calendarService: CalendarService,
	) {}


	ngOnInit() {

		const subscribedEventIds = this.calendarService.getSubscribedEventIds();

		this.calendarService.getPortalEvents().subscribe( events => {

			this.bLoading = false;
			this.subscribedEvents = events.filter( e => subscribedEventIds.includes( e.id ) );

		} );

	}


}

